import apiService from 'src/enviroment';

// Lista de solicitudes de permiso para acceder a un reporte
const getListPermission = async () => {
  try {
    const response = await apiService.get(
      '/admin/datastudio/solicitud/permiso/',
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

// Crear solicitud de permisos para acceder a un reporte
const postPermissionReport = async (params) => {
  try {
    const { status, data } = await apiService.post(
      '/admin/datastudio/solicitud/permiso/',
      params,
    );
    if (status === 200 && data.success === 1) {
      return { status: true, data };
    }
    return { status: false, data };
  } catch (error) {
    return false;
  }
};

// Rechazar o Aprobar solicitud de acceso a reportes
const putApproveReject = async (params) => {
  try {
    const { status, data } = await apiService.put(
      '/admin/datastudio/solicitud/permiso/',
      params,
    );
    if (status === 200 && data.success === 1) {
      return { status: true, data };
    }
    return { status: false, data };
  } catch (error) {
    return false;
  }
};
const deleteRequest = async (id) => {
  try {
    const response = await apiService.delete(
      `/admin/datastudio/solicitud/permiso/?id=${id}`,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const reportRequestPermissionsService = {
  getListPermission,
  postPermissionReport,
  putApproveReject,
  deleteRequest,
};

export default reportRequestPermissionsService;
